//  import { List as ImmutableList } from 'immutable';

import { createSelector } from 'reselect';

//  import { DateTime } from 'luxon';
import { INVESTMENTS_NEWSFEED_REDUCER_KEY } from './investmentsNewsfeedReducer';

export const getResourceStore = (state) => state[INVESTMENTS_NEWSFEED_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getError = (state) => getResourceStore(state).error;
export const getResourcesById = (state) => getResourceStore(state).resourcesById;

export const getArticlesByTickerSymbol = createSelector(
  getResourcesById,
  (state, props) => props.symbolsString,
  (state, props) => props.selectedSymbol,
  (articles, symbols, selectedSymbol) => {
    if (selectedSymbol) {
      const ret = articles.filter((article) => {
        return article.relatedSymbols.some((val) => val === selectedSymbol);
      });
      return ret;
    }
    // generate a lookup map
    const lookupSymbols = {};
    symbols?.split(',')?.forEach((symbol) => {
      lookupSymbols[symbol] = true;
    });
    const retVal = articles.filter((article) => {
      // likely means that qcs intentionally added article
      if (article.relatedSymbols.length === 0) {
        return true;
      }
      return article.relatedSymbols.some((val) => lookupSymbols[val]);
    });
    return retVal.take(30);
  },
);
